import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

export default function SessionWarningModal({ isOpen, onStayLoggedIn, onLogout }) {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[100]" onClose={() => {}}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-80 pointer-events-none" />
                </Transition.Child>
                <div className="fixed inset-0 z-[101] flex items-center justify-center p-4">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Dialog.Panel className="w-full max-w-[520px] transform overflow-hidden rounded-[10px]
                         bg-white text-left align-middle shadow-xl transition-all">
                            <div className="pt-[50px] pb-[35px] px-[60px]">
                                <p className="text-center text-[22px] text-[#343434] font-medium pb-[12px]">
                                    Still there?
                                </p>
                                <p className="text-center text-[14px] text-[#A1A1A9] font-medium pb-[27px]">
                                    You&apos;ve been inactive for a while and will be logged out of 
                                    this seller account in the next minute.
                                </p>
                                <p className="text-center text-[14px] text-[#343434] font-medium pb-[27px]">
                                    Do you want to stay logged in?
                                </p>
                                <div className="flex justify-center gap-[20px]">
                                    <button
                                        className="px-[31px] py-[12px] border border-[#A1A1A9] bg-white text-[#282828]
                                         leading-normal hover:bg-[#EFF1F8] font-medium text-[14px] rounded-[6px]"
                                        onClick={onLogout}
                                    >
                                        Log Out
                                    </button>
                                    <button
                                        className="px-[31px] py-[12px] bg-[#282828] text-[#FFFFFF] 
                                        leading-normal hover:bg-[#626465] font-medium text-[14px] rounded-[6px]"
                                        onClick={onStayLoggedIn}
                                    >
                                        Stay Logged In
                                    </button>
                                </div>
                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
}